import { graphql, useStaticQuery } from 'gatsby'

export const usePrismicRepositoryName = () => {
  const queryData = useStaticQuery(graphql`
    {
      sitePlugin(name: { eq: "gatsby-source-prismic" }) {
        pluginOptions {
          repositoryName
        }
      }
    }
  `)

  return queryData.sitePlugin.pluginOptions.repositoryName
}
